// action - state management
import * as actionTypes from './actions';

export const initialState = {
  userId: null,
  name: null,
  orgId: null
};

// ==============================|| User REDUCER ||============================== //

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      console.log('action.payload', action.payload);
      console.log('state', state);
      return {
        ...state,
        ...action.payload
      };
    case actionTypes.REMOVE_USER:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default userReducer;
